import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import axiosAuth from '../../config/axios';
import { ESTADO_COMPROMISO, RESPONSABLE_COMPROMISO, Chip, fecha, hora, estilos as s } from './comun';

// Portal del acudiente: solo lo que orientación marcó como visible para la
// familia (compromisos, citas y resultados de contactos). Nada más del caso.

const ESTADO_CITA_FAMILIA = {
  programada: { nombre: 'Programada', color: '#1565c0', fondo: '#e3f2fd' },
  realizada:  { nombre: 'Realizada',  color: '#2e7d32', fondo: '#e8f5e9' },
  cancelada:  { nombre: 'Cancelada',  color: '#6b7280', fondo: '#f1f2f4' },
};

function Seccion({ titulo, vacio, children, hay }) {
  return (
    <div style={{ marginTop: '16px' }}>
      <h4 style={es.subtitulo}>{titulo}</h4>
      {hay ? <div style={es.lista}>{children}</div> : <div style={es.vacio}>{vacio}</div>}
    </div>
  );
}

export default function OrientacionFamilia() {
  const [hijos, setHijos] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axiosAuth.get('/api/bienestar/familia')
      .then(r => setHijos(r.data.data || []))
      .catch(err => setError(err.response?.data?.error || 'No fue posible cargar esta sección.'));
  }, []);

  const ahora = new Date();
  return (
    <div style={s.pagina}>
      <Navbar titulo="Orientación" />
      <div style={es.contenido}>
        <div style={es.intro}>
          Aquí verás lo que el equipo de orientación del colegio comparte contigo: próximas citas,
          compromisos acordados y el resultado de las conversaciones. Si tienes dudas, escríbele al colegio por Mensajería.
        </div>
        {error && <div style={s.errorBox}>{error}</div>}
        {!error && !hijos && <p style={s.gris}>Cargando...</p>}
        {hijos && hijos.length === 0 && <div style={es.vacio}>No tienes estudiantes vinculados a tu cuenta.</div>}
        {hijos && hijos.map(h => {
          const hayAlgo = h.compromisos.length || h.citas.length || h.contactos.length;
          return (
            <div key={h.id} style={{ ...s.card, marginBottom: '16px' }}>
              <h3 style={es.nombre}>{h.nombre}</h3>
              {!hayAlgo ? (
                <div style={es.vacio}>Orientación no ha compartido información sobre este estudiante.</div>
              ) : (
                <>
                  <Seccion titulo="Citas" hay={h.citas.length} vacio="No hay citas.">
                    {h.citas.map(c => {
                      const def = ESTADO_CITA_FAMILIA[c.estado];
                      const pasada = new Date(c.inicio) < ahora;
                      return (
                        <div key={c.id} style={es.fila}>
                          <div style={{ flex: 1, minWidth: '180px' }}>
                            <div style={es.texto}>{fecha(c.inicio)} · {hora(c.inicio)}</div>
                            <div style={es.meta}>{c.lugar || 'Lugar por confirmar'}{c.profesional ? ` · con ${c.profesional}` : ''}</div>
                          </div>
                          {c.estado === 'programada' && pasada ? null : <Chip def={def} />}
                        </div>
                      );
                    })}
                  </Seccion>
                  <Seccion titulo="Compromisos" hay={h.compromisos.length} vacio="No hay compromisos compartidos.">
                    {h.compromisos.map(k => (
                      <div key={k.id} style={es.fila}>
                        <div style={{ flex: 1, minWidth: '180px' }}>
                          <div style={es.texto}>{k.descripcion}</div>
                          <div style={es.meta}>
                            Responsable: {RESPONSABLE_COMPROMISO[k.responsable_tipo]}{k.fecha_limite ? ` · hasta ${fecha(k.fecha_limite)}` : ''}
                          </div>
                        </div>
                        <Chip def={ESTADO_COMPROMISO[k.estado]} />
                      </div>
                    ))}
                  </Seccion>
                  <Seccion titulo="Conversaciones con orientación" hay={h.contactos.length} vacio="No hay registros compartidos.">
                    {h.contactos.map(c => (
                      <div key={c.id} style={{ ...es.fila, display: 'block' }}>
                        <div style={es.meta}>{fecha(c.fecha)}{c.tipo ? ` · ${c.tipo}` : ''}</div>
                        <div style={{ ...es.texto, whiteSpace: 'pre-wrap', marginTop: '4px' }}>{c.resultado}</div>
                      </div>
                    ))}
                  </Seccion>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

const es = {
  contenido: { padding: '24px', maxWidth: '850px', margin: '0 auto', width: '100%' },
  intro: { background: '#f3f1ff', border: '1px solid #e0dcff', color: '#4a4380', borderRadius: '12px', padding: '12px 16px', fontSize: '13.5px', lineHeight: 1.55, marginBottom: '16px' },
  nombre: { fontSize: '18px', fontWeight: 800, color: '#1a1a2e', margin: 0 },
  subtitulo: { fontSize: '12.5px', fontWeight: 800, color: '#555', textTransform: 'uppercase', letterSpacing: '0.3px', margin: '0 0 8px' },
  lista: { display: 'flex', flexDirection: 'column', gap: '8px' },
  fila: { display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap', border: '1px solid #eef0f5', borderRadius: '12px', padding: '10px 14px' },
  texto: { fontSize: '14px', color: '#333', lineHeight: 1.5 },
  meta: { fontSize: '12px', color: '#999', marginTop: '2px' },
  vacio: { background: '#fafbff', border: '1px dashed #dde0f0', borderRadius: '12px', padding: '14px', textAlign: 'center', color: '#999', fontSize: '13.5px', marginTop: '10px' },
};
